import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { useHistory } from "react-router-dom";
import "./style.scss";
import LineWithDot from "../../../../../assets/images/Line wit Dot.svg";
import iconTooltip from "../../../../../assets/svg/dashboard/iconTooltip.svg";
import AnimeList from "../../StartupDashboard/ViewAllMentorList/AnimeList";

import Pagination from "react-js-pagination";
import { Button as MaterialButton } from "@material-ui/core";
import hashImage from "../../../../../assets/images/hashImage.jpeg";
import { Country, State, City } from "country-state-city";
import swal from "sweetalert";
import profile from "../../../../../assets/svg/cohortMeetingCircle.svg";
import mentorshipMiniCircle from "../../../../../assets/svg/ mentroshipsMiniCircle.svg";
import {
  // getMentorCohortApplicationList,
  matchTableCohortList,
  matchTableStartupList,
  matchTableMentorList,
  postMatchTableRequest,
  getmatchTableList,
} from "../../MentorDashboard/dependencies/action";
import CohortSummaryModal from "../../../../common/cohortSummaryModal";
import CohortSummaryModal3 from "../../../../common/cohortSummaryModal3";
import api from "../../../../common/dependencies/utils/Api";

import axios from "axios";
import {
  COHORT_NAME_LIST,
  COHORT_ADMIN_COUNTER,
  COHORT_PARTICIPANT_COUNTER,
  COHORT_ENGAGED_MENTORS,
  COHORT_ENGAGED_STARTUPS,
  COHORT_APPLICATION_LIST,
} from "../../../../common/constants/ApplicationUrl";
import mentorMiniIcon from "../../../../../assets/svg/mentorsMiniCircle.svg";
import startupMiniCircle from "../../../../../assets/svg/startupMiniCircle.svg";
import buttonSendMessage from "../../../../../assets/images/Icon_Chat_Message.svg";
// import {
//   getStartupApplication,
//   getCountersStartUpList,
// } from "../dependencies/action";
import { getPredefineOptionsList } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import { getStepperTooltipData } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import * as moment from "moment";
import Modal from "../../StartupDashboard/MyRequests/Modal/modal";
import Select from "react-select";
import Button from "../../AdminDashboard/Button";
import mentorshipIcon2 from "../../../../../assets/svg/dashboard/view-Mentroships.svg";
import mentorshipIcon from "../../../../../assets/svg/cohortMeeting.svg";
import mentorshipIcon3 from "../../../../../assets/svg/startupMiniCircle.svg";
import mentorshipIcon4 from "../../../../../assets/svg/mentorsMiniCircle.svg";
import { getNamesList } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import { PROFILE_KEY } from "../../../../common/constants/actionConstants";
import * as CryptoJS from "crypto-js";
import {
  postMentorModuleCohort,
  postMentorModuleStartupCohort,
} from "../../MentorDashboard/dependencies/action";
const CohortMatchTable = (props) => {
  class AesUtil {
    constructor(keySize, iterationCount) {
      this.keySize = keySize / 32;
      this.iterationCount = iterationCount;
    }
  
    generateKey = function (salt, passPhrase) {
      let key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {
        keySize: this.keySize,
        iterations: this.iterationCount,
      });
      return key;
    };
  
    encrypt = function (salt, iv, passPhrase, plainText) {
      let key = this.generateKey(salt, passPhrase);
      let encrypted = CryptoJS.AES.encrypt(plainText, key, {
        iv: CryptoJS.enc.Hex.parse(iv),
      });
      return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    };
  }
  const html = document.getElementsByTagName("html")[0];
  const {
    getNamesList,
    getNamesListData,
    getMentorCohortApplicationList,
    postMentorModuleCohort,
    cohortStartupData,
    cohortMentorData,
    postMentorModuleStartupCohort,
    matchTableCohortList,
    matchTableStartupList,
    matchTableMentorList,
    postMatchTableRequest,
    getmatchTableList,
    cohortListTable,
    cohortMentorDropdown,
    cohortStartupDropdown,
    cohortMatchRequest,
    cohortMatchMakingList,
    cohortListTablePaginate,
  } = props;
  // const imageUrl = "https://uat-nmp-api.startupindia.gov.in/v1/document/;";
  const [activeText, setActiveText] = useState(false);
  const [activeText2, setActiveText2] = useState(false);
  const [activeText3, setActiveText3] = useState(false);
  const [activeText4, setActiveText4] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [selectedRow, setSelectedRow] = useState("");
  const LoginRole = JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role;
  const LoginUser = JSON.parse(localStorage.getItem("SavedLoggedInData"));
  const [mentorShipReqData, setMentorShipReqData] = useState();
  const [tableList, setTableList] = useState();
  const [modalOpen, setModalOpen] = useState(false);
  const history = useHistory();
  const [indexCounter, setIndexCounter] = useState(0);
  const [nameListValue, setNameListValue] = useState([]);
  const [filterName, setFilterName] = useState("");
  const [filterNameValue, setFilterNameValue] = useState("");
  const [filterCohortname, setFilterCohortname] = useState("");
  const [filterCohortId, setFilterCohortId] = useState("");
  const [cohortnameList, setcohortnameList] = useState([]);
  const [cohortnameId, setcohortnameId] = useState([]);
  const [cohortAdminCounter, setCohortAdminCounter] = useState({});
  const [cohortfilterGo, setcohortfilterGo] = useState(false);
  const [tableRow, setTableRow] = useState(false);
  const [tableRowData, setTableRowData] = useState(false);
  const [totalMentors, setTotalMentors] = useState(0);
  const [totalStartups, setTotalStartups] = useState(0);
  const [filterMentorData, setFilterMentorData] = useState();
  const [filterStartupData, setFilterStartupData] = useState();
  const [cohortIdTable, setCohortIdTable] = useState();
  const [engagedMentorData, setEngagedMentorData] = useState();
  const [engagedMentorPaginate, setEngagedMentorPaginate] = useState();
  const [engagedMentorDetails, setEngagedMentorDetails] = useState(false);

  const [availableMentorData, setAvailableMentorData] = useState();
  const [availableMentorPaginate, setAvailableMentorPaginate] = useState();
  const [availableMentorDetails, setAvailableMentorDetails] = useState(false);

  const [engagedStartupData, setEngagedStartupData] = useState();
  const [engagedStartupPaginate, setEngagedStartupPaginate] = useState();
  const [engagedStartupDetails, setEngagedStartupDetails] = useState(false);

  const [availableStartupData, setAvailableStartupData] = useState();
  const [availableStartupPaginate, setAvailableStartupPaginate] = useState();
  const [availableStartupDetails, setAvailableStartupDetails] = useState(false);

  const defaultFormData = {
    search: "",
    industry: null,
    specialization: null,
    stage: null,
    recognized: "",
    state: "",
    country: "",
  };
  const [mentorFilterDropdDown, setMentorFilterDropdDown] = useState([]);
  const [startupFilterDropdDown, setStartupFilterDropdDown] = useState([]);
  const newCountryArray = [];
  const newStateArray = [];
  const [selectedStatus, setSelectedStatus] = useState("");
  const [formData, setFormData] = useState(defaultFormData);
  const [newCountryOptions, setNewCountryOptions] = useState(newCountryArray);
  const [newStateOptions, setNewStateOptions] = useState(newStateArray);
  const [newCountrySelect, setNewCountrySelect] = useState(false);
  const [allMentorNames, setAllMentorNames] = useState();
  const [filterIndustry, setFilterIndustry] = useState("");
  const [filterFunction, setFilterFunction] = useState("");
  const [filterStage, setFilterStage] = useState("");
  const [filterState, setFilterState] = useState("");
  const [filterCountry, setFilterCountry] = useState("");
  const [modalVisibility, setModalVisibility] = useState(false);
  const [modalVisibility2, setModalVisibility2] = useState(false);
  const [fromModule, setFromModule] = useState("");
  const [modalData, setModalData] = useState("");
  const [cohortModalData, setCohortModalData] = useState("");
  const [cohortModalData2, setCohortModalData2] = useState("");
  const [cohortModalMentorData, setCohortModalMentorData] = useState([]);
  const [cohortModalStartupData, setCohortModalStartupData] = useState([]);
  const [cohortData, setCohortData] = useState();
  const [matchMakingList, setMatchMakingList] = useState([]);
  const [isShown, setIsShown] = useState(false);
  const [Heading, setHeading] = useState();
  const [InstructionswithRole, setInstructionswithRole] = useState();
  const [SelectPage, setSelectPage] = useState();
  const [isCohort, setIsCohort] = useState();
  const setModalIsOpenToTrue = () => {
    setIsShown(!isShown);
  };

  const {
    getStartupApplication,
    startUpApplication,
    startUpApplicationPagineate,
    getTableDataPaginate,
    getTableData,
    getCountersStartUpList,
    getCounterStartUp,
    getPredefineOptionsList,
    getPredefineOptions,
    getStepperTooltipData,
    getStepperData,
  } = props;
  const currentRoute = window.location.href;
  let sample;
  sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));

  const loginrole = JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role;
  if (loginrole === "Mentor") {
    if (isCohort === true) {
      localStorage.setItem("cohortMatchTable", "cohortMatchTable");
    }
  } else {
    localStorage.removeItem("cohortMatchTable");
    history.push("/startup-dashboard");
  }
  useEffect(() => {
    html.style.overflow = "auto";

    // localStorage.setItem("cohortMatchTable", "cohortMatchTable");
    setTimeout(() => {
      localStorage.removeItem("mentorMentorships");
      localStorage.removeItem("cohortMentors");
      localStorage.removeItem("cohortStartup");
      localStorage.removeItem("myrequestMenu");
      localStorage.removeItem("startupListMentor");
      localStorage.removeItem("cohortAdminMentorships");
      localStorage.removeItem("CohortMentorRequest");
      localStorage.removeItem("cohortApplicationMentor");
      localStorage.removeItem("cohortProgram");
      localStorage.removeItem("CohortGroupSession");

      // localStorage.removeItem("cohortMatchTable");
    }, 1000);
    if (props?.location?.state?.requestStatus === undefined) {
      setActiveText(true);
    } else if (props?.location?.state?.requestStatus === "pending") {
      setActiveText2(true);
    } else if (props.location.state.requestStatus === "viewAll") {
      setActiveText(true);
    } else setActiveText(true);
  }, []);

  useEffect(() => {
    let value = localStorage.getItem("SavedLoggedInData");
    // let LoginFormData = JSON.parse(value);

    // axios({
    //   url: COHORT_APPLICATION_LIST,
    //   method: "post",
    //   data: {
    //     cohortAdminId: JSON.parse(value)?.id,
    //     sortKey: "name",
    //     sortOrder: "ASC",
    //     country: null,
    //     state: null,
    //     industry: "",
    //     function: "",
    //     stage: "",
    //     searchField: JSON.parse(value).id,
    //     searchKey: null,
    //     status: "VERIFIED",
    //     pageFilter: {
    //       currentPage: 0,
    //       includeCount: true,
    //       pageSize: 10,
    //       sortField: "date_applied",
    //       sortOrder: "DESC",
    //     },
    //   },
    // })
    api
      .POST(COHORT_APPLICATION_LIST, {
        cohortAdminId: JSON.parse(value)?.id,
        sortKey: "name",
        sortOrder: "ASC",
        country: null,
        state: null,
        industry: "",
        function: "",
        stage: "",
        searchField: JSON.parse(value).id,
        searchKey: null,
        status: "VERIFIED",
        pageFilter: {
          currentPage: 0,
          includeCount: true,
          pageSize: 10,
          sortField: "date_applied",
          sortOrder: "DESC",
        },
      })
      .then((res) => {
        if (res.data?.data?.length > 0) {
          setIsCohort(true);
        } else {
          setIsCohort(false);
        }
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    let params = {
      listKey: "Startup",
    };
    getNamesList(params);
  }, []);
  useEffect(() => {
    if (getTableData && getTableData.length > 0) setCohortData(getTableData);
  }, [getTableData]);

  useEffect(() => {
    let params = {
      cohortAdminId: LoginUser.id,
      cohortId: "",
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "",
        sortOrder: "DESC",
      },
    };
    matchTableCohortList(params);
  }, []);
  useEffect(() => {
    setCohortData(cohortListTable);
  }, [cohortListTable]);
  useEffect(() => {
    const defaultDrop = {
      value: "select",
      label: "Select Mentor",
    };
    if (
      cohortMentorDropdown &&
      cohortMentorDropdown.length > 0 &&
      mentorFilterDropdDown.length == 0
    ) {
      cohortMentorDropdown.forEach((element, index) => {
        if (index == 0) {
          setMentorFilterDropdDown((prevState) => [...prevState, defaultDrop]);
        }
        let item = {
          label: element.name,
          value: element.id,
        };
        setMentorFilterDropdDown((prevState) => [...prevState, item]);
      });
    }

    // setCohortData(cohortListTable)
  }, [cohortMentorDropdown]);
  useEffect(() => {
    const defaultDrop = {
      value: "select",
      label: "Select Startup",
    };
    if (
      cohortStartupDropdown &&
      cohortStartupDropdown.length > 0 &&
      startupFilterDropdDown.length == 0
    ) {
      cohortStartupDropdown.forEach((element, index) => {
        if (index == 0) {
          setStartupFilterDropdDown((prevState) => [...prevState, defaultDrop]);
        }
        let item = {
          label: element.name,
          value: element.id,
        };
        setStartupFilterDropdDown((prevState) => [...prevState, item]);
      });
    }
  }, [cohortStartupDropdown]);
  useEffect(() => {
    setMatchMakingList(cohortMatchMakingList);
    // setCohortData(cohortListTable)
  }, [cohortMatchMakingList]);

  const startupDropdownList = (cohortId) => {
    let params = {
      cohortAdminId: LoginUser.id,
      cohortId: cohortId,
    };
    matchTableStartupList(params);
  };
  const mentorDropdownList = (cohortId) => {
    let params = {
      cohortAdminId: LoginUser.id,
      cohortId: cohortId,
    };
    matchTableMentorList(params);
  };
  const createMentorMatchInitial = (cohortId) => {
    let params = {
      cohortAdminId: LoginUser.id,
      cohortId: cohortId,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "name",
        sortOrder: "ASC",
      },
    };
    getmatchTableList(params);
  };
  const createMentorMatch = () => {
    if (
      cohortIdTable === undefined ||
      filterMentorData === undefined ||
      filterStartupData === undefined
    ) {
      swal({
        title: "Info!",
        text: "Please select Mentor and Startup item of a Cohort Program",
        icon: "info",
        showCancelButton: true,
        // buttons: false,
      });
    } else if (
      cohortIdTable !== undefined &&
      filterMentorData !== undefined &&
      filterStartupData !== undefined
    ) {
      let params = {
        cohortAdminId: LoginUser.id,
        cohortId: cohortIdTable,
        mentorId: filterMentorData.value,
        startupId: filterStartupData.value,
      };
      postMatchTableRequest(params);
      setTimeout(() => {
        getMentorsMatches(filterMentorData.value);
        getStartupMatches(filterStartupData.value);
      }, 2000);
    }
  };

  const getMentorsMatches = (mentorId) => {
    let params = {
      cohortAdminId: LoginUser.id,
      cohortId: cohortIdTable,
      mentorId: mentorId,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "name",
        sortOrder: "ASC",
      },
    };
    getmatchTableList(params);
  };
  const getStartupMatches = (startupId) => {
    let params = {
      cohortAdminId: LoginUser.id,
      cohortId: cohortIdTable,
      startupId: startupId,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "name",
        sortOrder: "ASC",
      },
    };
    getmatchTableList(params);
  };

  useEffect(() => {
    let nameArrList = [];
    getNamesListData?.forEach((element, index) => {
      if (index === 0) {
        let arr2 = {
          value: "Select",
          label: "Select Startup",
        };
        setNameListValue((oldArray) => [...oldArray, arr2]);
      }
      let arr = {
        value: element.id,
        label: element.name,
      };
      if (getNamesListData.length >= nameListValue.length)
        setNameListValue((oldArray) => [...oldArray, arr]);
    });
  }, [getNamesListData]);

  useEffect(() => {
    if (LoginRole === "Mentor") {
      // axios({
      //   url: COHORT_NAME_LIST,
      //   method: "post",
      //   data: {
      //     mentorId:
      //       localStorage.getItem("SavedLoggedInData") &&
      //       JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      //     status: "VERIFIED",
      //   },
      // })
      api
        .POST(COHORT_NAME_LIST, {
          mentorId:
            localStorage.getItem("SavedLoggedInData") &&
            JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
          status: "VERIFIED",
        })
        .then((res) => {
          const cohortnameArray = [];
          // setCounterData(res.data?.data)
          res.data.data &&
            res.data.data.forEach((item, index) => {
              if (index === 0) {
                let arr2 = {
                  value: "select",
                  label: "Select Cohort",
                };
                setcohortnameList((oldArray) => [...oldArray, arr2]);
              }
              const params = {
                label: item.name,
                value: item.id,
              };
              setcohortnameList((oldArray) => [...oldArray, params]);
              // cohortnameArray.push(params);
            });
        })
        .catch((err) => {});

      // axios({
      //   url: COHORT_ADMIN_COUNTER,
      //   method: "post",
      //   data: {
      //     cohortAdminId:
      //       localStorage.getItem("SavedLoggedInData") &&
      //       JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      //   },
      // })
      api
        .POST(COHORT_ADMIN_COUNTER, {
          cohortAdminId:
            localStorage.getItem("SavedLoggedInData") &&
            JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
        })
        .then((res) => {
          // const cohortnameArray = [];

          setCohortAdminCounter(res.data.data);
        })
        .catch((err) => {});
    } else {
      // axios({
      //   url: COHORT_NAME_LIST,
      //   method: "post",
      //   data: {},
      // })
      api
        .POST(COHORT_NAME_LIST, {})
        .then((res) => {
          const cohortnameArray = [];
          // setCounterData(res.data?.data)
          res.data.data &&
            res.data.data.map((item, value) => {
              const params = {
                label: item.name,
                value: item.id,
              };
              cohortnameArray.push(params);
            });

          setcohortnameList(cohortnameArray);
          // setcohortnameId(cohortidArray);
        })
        .catch((err) => {});

      // axios({
      //   url: COHORT_NAME_LIST,
      //   method: "post",
      //   data: {
      //     status: "VERIFIED",
      //   },
      // })
      api
        .POST(COHORT_NAME_LIST, {
          status: "VERIFIED",
        })
        .then((res) => {
          const cohortidArray = [];

          res.data.data &&
            res.data.data.map((item, value) => {
              const params = {
                label: `M${item.id.slice(-6)}`,
                value: item.id,
              };
              cohortidArray.push(params);
            });
          setcohortnameId(cohortidArray);
        })
        .catch((err) => {});
    }
  }, []);

  useEffect(() => {
    getPredefineOptionsList();
    Country.getAllCountries().map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newCountryArray.push(newObject);
      setNewCountryOptions(newCountryArray);
    });
    State.getStatesOfCountry("IN").map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newStateArray.push(newObject);
      setNewStateOptions(newStateArray);
    });
  }, []);
  const customStyles = {
    option: (provided, state) => ({
      ...provided,

      textAlign: "left",
    }),
    menu: (base) => ({
      ...base,
      width: "max-content",
      minWidth: "100%",
      fontSize: "14px",
    }),
  };
  useEffect(() => {
    getPredefineOptionsList();
  }, []);

  const redirectProfile = (item) => {
    let reRoute = window.open(`/startup-profile/${item}`, "_blank");
    reRoute.id = item;
  };
  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    let params = {
      cohortAdminId: LoginUser.id,
      cohortId: "",
      pageFilter: {
        currentPage: pageNumber - 1,
        includeCount: true,
        pageSize: 10,
        sortField: "",
        sortOrder: "DESC",
      },
    };

    matchTableCohortList(params);
  };
  useEffect(() => {
    if (cohortStartupData && cohortStartupData.length > 0)
      cohortStartupData.forEach((element) => {
        setCohortModalMentorData((data) => [...data, element.startup]);
      });
  }, [cohortStartupData]);
  useEffect(() => {
    getStepperTooltipData();
  }, []);
  useEffect(() => {
    setHeading(getStepperData?.Guidedinstructions[0].Heading);
    setInstructionswithRole(
      getStepperData?.Guidedinstructions[0].InstructionswithRole
    );
    setSelectPage(getStepperData?.Guidedinstructions[0].SelectPage);
  }, [getStepperData]);
  useEffect(() => {
    if (cohortMentorData && cohortMentorData.length > 0)
      cohortMentorData.forEach((element) => {
        setCohortModalMentorData((data) => [...data, element.mentor]);
      });
  }, [cohortMentorData]);

  const ViewProfile = (item, id) => {
    setSelectedRow(id);
    let reRoute = window.open(sample + `/mentor-profile/${encryptAES2(item,PROFILE_KEY)}`, "_blank");
    // let reRoute = window.open(sample + `/mentor-profile/${item}`, "_blank");
    reRoute.id = item;
  };
  const encryptAES2 = (text, key) => {
    // let iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    // let salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
  
    // let aesUtil = new AesUtil(128, 1000);
    // let ciphertext = aesUtil.encrypt(salt, iv, key, text);
  
    // let aesText = iv + "::" + salt + "::" + ciphertext;
    
    return btoa(text);
  };
  const engagedMentors = (id, adminId) => {
    // axios({
    //   url: COHORT_ENGAGED_MENTORS,
    //   method: "post",
    //   data: {
    //     cohortId: id,
    //     mentorId: "",
    //     // cohortAdminId: adminId,
    //     cohortAdminId: "",
    //     requestStatus: "Accepted",
    //     pageFilter: {
    //       currentPage: 0,
    //       includeCount: true,
    //       pageSize: 5,
    //       sortField: "id",
    //       sortOrder: "ASC",
    //     },
    //     searchField: "",
    //     searchKey: "",
    //     engStatus: "Engagged",
    //   },
    // })
    api
      .POST(COHORT_ENGAGED_MENTORS, {
        cohortId: id,
        mentorId: "",
        // cohortAdminId: adminId,
        cohortAdminId: "",
        requestStatus: "Accepted",
        pageFilter: {
          currentPage: 0,
          includeCount: true,
          pageSize: 5,
          sortField: "id",
          sortOrder: "ASC",
        },
        searchField: "",
        searchKey: "",
        engStatus: "Engagged",
      })
      .then((res) => {
        setEngagedMentorData(res.data.data);
        setEngagedMentorPaginate(res.data.paginate);
      })
      .catch((err) => {});
  };
  const availableMentors = (id, adminId) => {
    // axios({
    //   url: COHORT_ENGAGED_MENTORS,
    //   method: "post",
    //   data: {
    //     cohortId: id,
    //     mentorId: "",
    //     // cohortAdminId: adminId,
    //     cohortAdminId: "",
    //     requestStatus: "Accepted",
    //     pageFilter: {
    //       currentPage: 0,
    //       includeCount: true,
    //       pageSize: 5,
    //       sortField: "id",
    //       sortOrder: "ASC",
    //     },
    //     searchField: "",
    //     searchKey: "",
    //     engStatus: "Available",
    //   },
    // })
    api
      .POST(COHORT_ENGAGED_MENTORS, {
        cohortId: id,
        mentorId: "",
        // cohortAdminId: adminId,
        cohortAdminId: "",
        requestStatus: "Accepted",
        pageFilter: {
          currentPage: 0,
          includeCount: true,
          pageSize: 5,
          sortField: "id",
          sortOrder: "ASC",
        },
        searchField: "",
        searchKey: "",
        engStatus: "Available",
      })
      .then((res) => {
        setAvailableMentorData(res.data.data);
        setAvailableMentorPaginate(res.data.paginate);
      })
      .catch((err) => {});
  };
  const engagedStartups = (id, adminId) => {
    // axios({
    //   url: COHORT_ENGAGED_STARTUPS,
    //   method: "post",
    //   data: {
    //     cohortId: id,
    //     mentorId: "",
    //     // cohortAdminId: adminId,
    //     cohortAdminId: "",

    //     requestStatus: "Accepted",
    //     pageFilter: {
    //       currentPage: 0,
    //       includeCount: true,
    //       pageSize: 5,
    //       sortField: "id",
    //       sortOrder: "ASC",
    //     },
    //     searchField: "",
    //     searchKey: "",
    //     engStatus: "Engagged",
    //   },
    // })
    api
      .POST(COHORT_ENGAGED_STARTUPS, {
        cohortId: id,
        mentorId: "",
        // cohortAdminId: adminId,
        cohortAdminId: "",

        requestStatus: "Accepted",
        pageFilter: {
          currentPage: 0,
          includeCount: true,
          pageSize: 5,
          sortField: "id",
          sortOrder: "ASC",
        },
        searchField: "",
        searchKey: "",
        engStatus: "Engagged",
      })
      .then((res) => {
        // const cohortnameArray = [];
        setEngagedStartupData(res.data.data);
        setEngagedStartupPaginate(res.data.paginate);
      })
      .catch((err) => {});
  };
  const availableStartups = (id, adminId) => {
    // axios({
    //   url: COHORT_ENGAGED_STARTUPS,
    //   method: "post",
    //   data: {
    //     cohortId: id,
    //     mentorId: "",
    //     // cohortAdminId: adminId,
    //     cohortAdminId: "",

    //     requestStatus: "Accepted",
    //     pageFilter: {
    //       currentPage: 0,
    //       includeCount: true,
    //       pageSize: 5,
    //       sortField: "id",
    //       sortOrder: "ASC",
    //     },
    //     searchField: "",
    //     searchKey: "",
    //     // mentorId:
    //     //   localStorage.getItem("SavedLoggedInData") &&
    //     //   JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    //     // status: "VERIFIED",
    //     engStatus: "Available",
    //   },
    // })
    api
      .POST(COHORT_ENGAGED_STARTUPS, {
        cohortId: id,
        mentorId: "",
        // cohortAdminId: adminId,
        cohortAdminId: "",

        requestStatus: "Accepted",
        pageFilter: {
          currentPage: 0,
          includeCount: true,
          pageSize: 5,
          sortField: "id",
          sortOrder: "ASC",
        },
        searchField: "",
        searchKey: "",
        // mentorId:
        //   localStorage.getItem("SavedLoggedInData") &&
        //   JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
        // status: "VERIFIED",
        engStatus: "Available",
      })
      .then((res) => {
        setAvailableStartupData(res.data.data);
        setAvailableStartupPaginate(res.data.paginate);
      })
      .catch((err) => {});
  };
  return (
    <>
      <div className="chrtadminmatchmkngmenloginmaindiv">
        <div
          className="dashboard-main2 matchmakingdiv"
          style={{ background: "none" }}
        >
          <div
            className="dashboard-bottom-btn4 topbackbtnmentorlist"
            style={{ background: "transparent", border: "none" }}
          >
            <div className="newuserTooltip">
              <MaterialButton
                className="topbackbtnactual top-btn"
                variant="contained"
                color="primary"
                onClick={() => {
                  if (LoginRole === "Mentor") {
                    if (
                      history?.location?.state?.fromModule !== undefined &&
                      history?.location?.state?.fromModule !== null &&
                      history?.location?.state?.fromModule ===
                        "cohortStartupRequest"
                    ) {
                      props.setSelectedMenu("cohortStartup");
                      history.push("/dashboard");
                    } else if (
                      history?.location?.state?.fromModule !== undefined &&
                      history?.location?.state?.fromModule !== null &&
                      history?.location?.state?.fromModule ===
                        "cohortMentorApplication"
                    ) {
                      props.setSelectedMenu("cohortApplicationMentor");
                      history.push("/dashboard");
                    } else if (
                      history?.location?.state?.fromModule !== undefined &&
                      history?.location?.state?.fromModule !== null &&
                      history?.location?.state?.fromModule ===
                        "cohortMentorRequest"
                    ) {
                      props.setSelectedMenu("cohortMentors");
                      history.push("/dashboard");
                    } else {
                      props.setSelectedMenu("adminMenu");
                      history.push("/dashboard");
                    }
                  } else {
                    if (
                      history?.location?.state?.fromModule === "activitySummary"
                    ) {
                      localStorage.setItem(
                        "activitySummary",
                        "activitySummary"
                      );

                      window.location.reload();
                      // cohortApplication
                    } else {
                      props.setSelectedMenu("cohortApplication");
                      history.push("/dashboard");
                    }
                  }
                  // localStorage.setItem(
                  //   "mentorDashboardHome",
                  //   "mentorDashboardHome"
                  // );

                  // window.location.reload();
                }}
                style={{ background: "#3ac2d7" }}
              >
                {" "}
                Back
              </MaterialButton>
              <span
                className="tooltiptext tooltip-bottom"
                style={{
                  top: "69px",
                  width: "200px",
                  left: "71px",
                }}
              >
                Click to Go My Dashboard
              </span>
            </div>
            <Modal
              modalOpen={modalOpen}
              setModalOpen={setModalOpen}
              modalData={modalData}
            />
            {modalVisibility && (
              <CohortSummaryModal
                setModalVisibility={setModalVisibility}
                fromModule={fromModule}
                modalVisibility={modalVisibility}
                cohortId={cohortModalData}
                cohortAdminId={cohortModalData2}
                fromPage={"mentorships"}
                fromPage2={"matchMaking"}
              />
            )}
            {modalVisibility2 && (
              <CohortSummaryModal3
                data={
                  engagedMentorDetails === true
                    ? engagedMentorData
                    : availableMentorDetails === true
                    ? availableMentorData
                    : engagedStartupDetails === true
                    ? engagedStartupData
                    : availableStartupData
                }
                engagedMentorPaginate={
                  engagedMentorDetails === true
                    ? engagedMentorPaginate
                    : availableMentorDetails === true
                    ? availableMentorPaginate
                    : engagedStartupDetails === true
                    ? engagedStartupPaginate
                    : availableStartupPaginate
                }
                cohortId={cohortModalData}
                setEngagedMentorDetails={engagedMentorDetails}
                setAvailableMentorDetails={availableMentorDetails}
                setEngagedStartupDetails={engagedStartupDetails}
                setAvailableStartupDetails={availableStartupDetails}
                setModalVisibility={setModalVisibility2}
                // fromModule={fromModule}
                modalVisibility={modalVisibility2}
                cohortAdminId={cohortModalData2}
                fromPage={"mentorships"}
                fromPage2={"matchMaking"}
              />
            )}
          </div>
          <div className="iconWith-heading cohortappiconwith">
            <div style={{ width: "100%" }}>
              <h3
                className="sub-heading fadeInDown wow"
                style={{ color: "#262838", fontWeight: 600, fontSize: "28px" }}
              >
                MAARG Portal by Startup India
              </h3>
              <h3 className="dashboard-sub-heading fadeInDown wow">
                COHORT ADMIN: MATCH MENTORS TO STARTUPS
              </h3>
            </div>
            <div
              className="tooltipshow eyeIcon"
              // onClick={() => {
              //   // html.style.overflow = "hidden";
              //   if (html.style.overflow == "auto") {
              //     html.style.overflow = "hidden";
              //   } else {
              //     html.style.overflow = "auto";
              //   }
              // }}
            >
              <div className="newuserTooltip">
                <img
                  className="iconbtn top-btn"
                  src={iconTooltip}
                  onClick={() => {
                    setModalIsOpenToTrue();
                    if (html.style.overflow == "auto") {
                      html.style.overflow = "hidden";
                    } else {
                      html.style.overflow = "auto";
                    }
                  }}
                  width={60}
                />{" "}
                <span
                  className="tooltiptext tooltip-bottom "
                  style={{ width: "130px", top: "50px", left: "20px" }}
                >
                  View Instructions
                </span>
              </div>
            </div>
            {isShown && (
              <div>
                <AnimeList
                  setModalIsOpenToTrue={setModalIsOpenToTrue}
                  Heading={Heading}
                  InstructionswithRole={InstructionswithRole}
                  SelectPage={SelectPage}
                />
              </div>
            )}
          </div>
        </div>

        <div className="col-md-11 display-center mobileviewcohortappli">
          <div className="admin-bottom-cardNew002 row mobileviewmentorbelow">
            <div
              className="mentorImageParent newmentorparent"
              style={{
                background: "none",
                border: "0px",
                borderRadius: "0px",
                position: "relative",
                marginLeft: "4rem",
              }}
            >
              <img src={mentorshipIcon} className="sidebar-dashboard-icon3" />
            </div>
            <div
              className="col-xs-6 col-sm-6 col-md-2 col-lg-2 mentorAppButton newappbtnnew"
              style={{ position: "relative", marginLeft: "2rem" }}
            >
              <div className="dashboard-bottom-btn2005">
                <p className="text-white2"> COHORT STATUS</p>
              </div>
            </div>
            <div
              className="col-xs-6 col-sm-6 col-md-2 col-lg-2  newuserTooltip matchmakingheader1"
              style={{
                position: "relative",
                // marginLeft: "1rem",
                // cursor: "pointer",
              }}
            >
              <p
                onClick={() => {
                  setActiveText(true);
                  setActiveText2(false);
                  setActiveText3(false);
                  setActiveText4(false);
                  // setSelectedStatus("");
                  //   getStartupApplicationTable("");
                }}
                style={{
                  color: "#838186",
                  cursor: "unset",
                }}
                className="admindasheaderoptions"
              >
                TOTAL COHORTS : {cohortAdminCounter.totalCohorts}
                {/* {getCounterStartUp && getCounterStartUp.totalSearch !== null
                  ? getCounterStartUp.totalSearch
                  : 0} */}
              </p>
              {/* <span
                className="tooltiptext   tooltip-bottom"
                style={{ left: "45px", width: "200px" }}
              >
                Click to View Total Cohorts
              </span> */}
            </div>
            <div
              className="col-xs-6 col-sm-6 col-md-2 col-lg-2 newuserTooltip matchmakingheader2"
              style={{
                position: "relative",
                // marginLeft: "2rem",
                // cursor: "pointer",
              }}
            >
              <p
                onClick={() => {
                  setActiveText2(true);
                  setActiveText(false);
                  setActiveText3(false);
                  setActiveText4(false);
                  setSelectedStatus("COMPLETED");
                  //   getStartupApplicationTable("PENDING");
                  // getMentorApplications("PENDING");
                }}
                style={{ color: "#838186", cursor: "unset" }}
                className="admindasheaderoptions applicationHeading90"
              >
                {" "}
                TOTAL MENTORS : {cohortAdminCounter.totalMentors}
                {/* {getCounterStartUp && getCounterStartUp.pending !== null
                  ? getCounterStartUp.pending
                  : 0} */}
              </p>
              {/* <span
                className="tooltiptext   tooltip-bottom"
                style={{ left: "45px", width: "200px" }}
              >
                Click to View Total Mentors
              </span> */}
              {/* {activeText2 ? (
                <img
                  className="requestStatusBar positionBar00050"
                  src={LineWithDot}
                />
              ) : (
                ""
              )} */}
            </div>
            <div
              className="col-xs-6 col-sm-6 col-md-2 col-lg-2 newuserTooltip matchmakingheader3"
              style={{
                position: "relative",
                // marginLeft: "2rem",
                // cursor: "pointer",
              }}
            >
              <p
                onClick={() => {
                  setActiveText2(false);
                  setActiveText(false);
                  setActiveText3(true);
                  setActiveText4(false);
                  setSelectedStatus("COMPLETED");
                  //   getStartupApplicationTable("PENDING");
                  // getMentorApplications("PENDING");
                }}
                style={{ color: "#838186", cursor: "unset" }}
                className="admindasheaderoptions applicationHeading89"
              >
                {" "}
                TOTAL STARTUPS : {cohortAdminCounter.totalStartups}
                {/* {getCounterStartUp && getCounterStartUp.pending !== null
                  ? getCounterStartUp.pending
                  : 0} */}
              </p>
              {/* <span
                className="tooltiptext   tooltip-bottom"
                style={{ left: "45px", width: "200px" }}
              >
                Click to View Total Startups
              </span> */}
              {/* {activeText3 ? (
                <img
                  className="requestStatusBar positionBar00050"
                  src={LineWithDot}
                />
              ) : (
                ""
              )} */}
            </div>
          </div>
          <div className="filter-row filter-row-common filterDivMentorapp">
            <div>
              <form className="formContainer">
                <div className="row desktopFilterRow ">
                  <div className="col-12 d-flex newflexdiv">
                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip">
                      <Select
                        required={true}
                        id="cohortorgname"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="cohortorgname"
                        className="col-12 gendermentorinput "
                        styles={customStyles}
                        value={formData.cohortorgname}
                        onChange={(e) => {
                          setFilterMentorData("");
                          setFilterStartupData("");
                          setFormData((user) => {
                            return {
                              ...user,
                              cohortorgname: e.value == "select" ? null : e,
                            };
                          });
                          let valueTest = e.value;
                          if (e.value !== "select") {
                            // mentorDropdownList(e.value);
                            // startupDropdownList(e.value);
                            // setCohortIdTable(e.value);
                            // createMentorMatchInitial(e.value)
                            let filterArr = cohortListTable.filter(function (
                              item
                            ) {
                              return item.cohortId === valueTest;
                            });
                            setMentorFilterDropdDown([]);
                            setStartupFilterDropdDown([]);
                            setTimeout(() => {
                              setTableRow(true);
                              setCohortData(filterArr);
                              mentorDropdownList(filterArr[0].cohortId);
                              startupDropdownList(filterArr[0].cohortId);
                              setCohortIdTable(filterArr[0].cohortId);
                              createMentorMatchInitial(filterArr[0].cohortId);
                            }, 1000);
                          } else {
                            setTableRow(false);
                            setMentorFilterDropdDown([]);
                            setStartupFilterDropdDown([]);
                            setCohortIdTable();
                            setCohortData(cohortListTable);
                            createMentorMatchInitial("");
                          }

                          // setFilterCohortId(e.value);
                          // showSelectedCohort(e.value);
                        }}
                        options={cohortnameList}
                        placeholder="Select Cohort"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "140px" }}
                      >
                        Search Cohort
                      </span>
                    </div>
                    {/* <div className="totalTableCount cohortMatchCount" style={{whiteSpace:"nowrap"}}>
                      Total Mentors : {totalMentors}
                    </div>
                    <div className="totalTableCount cohortMatchCount" style={{whiteSpace:"nowrap"}}>
                      Total Startups : {totalStartups}
                    </div> */}
                    {cohortListTablePaginate && !tableRow && (
                      <div
                        className="totalTableCount cohortMatchCount col-9"
                        style={{ marginLeft: "4.8rem" }}
                      >
                        Total Cohort Programs :{" "}
                        {/* {tableRow
                        ? cohortData?.length
                        : cohortListTablePaginate?.totalElements}{" "}
                      &lt; {activePage && activePage} of{" "}
                      {cohortListTablePaginate?.currentPage} &gt; */}
                        {cohortListTablePaginate?.totalElements} &lt;{" "}
                        {activePage && activePage} of{" "}
                        {cohortListTablePaginate?.currentPage} &gt;
                      </div>
                    )}
                  </div>
                </div>

                <div className="row mobileFilterRow">
                  {/* <div className="col-md-1 filter-text">Filter by</div> */}
                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="cohortorgname"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="cohortorgname"
                      className="col-12 gendermentorinput "
                      styles={customStyles}
                      value={formData.cohortorgname}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            cohortorgname: e.value == "select" ? null : e,
                          };
                        });
                        let valueTest = e.value;
                        if (e.value !== "select") {
                          // mentorDropdownList(e.value);
                          // startupDropdownList(e.value);
                          // setCohortIdTable(e.value);
                          // createMentorMatchInitial(e.value)
                          let filterArr = cohortListTable.filter(function (
                            item
                          ) {
                            return item.cohortId === valueTest;
                          });
                          setMentorFilterDropdDown([]);
                          setStartupFilterDropdDown([]);
                          setTimeout(() => {
                            setTableRow(true);
                            setCohortData(filterArr);
                            mentorDropdownList(filterArr[0].cohortId);
                            startupDropdownList(filterArr[0].cohortId);
                            setCohortIdTable(filterArr[0].cohortId);
                            createMentorMatchInitial(filterArr[0].cohortId);
                          }, 1000);
                        } else {
                          setTableRow(false);
                          setMentorFilterDropdDown([]);
                          setStartupFilterDropdDown([]);
                          setCohortIdTable();
                          setCohortData(cohortListTable);
                          createMentorMatchInitial("");
                        }

                        // setFilterCohortId(e.value);
                        // showSelectedCohort(e.value);
                      }}
                      options={cohortnameList}
                      placeholder="Select Cohort"
                    />
                  </div>
                  {/* <div
                    className="col-md-1 apply-section"
                    style={{ color: "transparent" }}
                  >
                    <Button
                      className="green-btn filter-btn"
                      //   onClick={() => getStartupApplicationTable(selectedStatus)}
                      text="Apply"
                    />
                  </div> */}
                </div>
              </form>
            </div>
          </div>

          {/* <div className="totalTableCount">
            Total Cohort Applications Found :{" "}
            {getTableDataPaginate?.totalElements} &lt;{" "}
            {getTableDataPaginate?.currentPage} of{" "}
            {getTableDataPaginate?.numPages} &gt;{" "}
          </div> */}
          {/* {startUpApplication && startUpApplication?.length > 0 ? ( */}
          <div className="chrtadminmatchmkngmenloginmaindivtable1">
            <div className="table-container mt-2">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th
                      style={{ verticalAlign: "top" }}
                      className="fixColumbnWidth4"
                    >
                      {" "}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "left",
                          alignItems: "center",
                        }}
                      >
                        NO.
                      </div>
                    </th>
                    <th
                      style={{ verticalAlign: "top" }}
                      className="fixColumbnWidth"
                      colspan="2"
                    >
                      <div>COHORT DETAILS</div>
                    </th>
                    <th style={{ verticalAlign: "top" }}>
                      <div>TOTAL MENTORS</div>
                    </th>
                    <th style={{ verticalAlign: "top" }}>
                      <div>MENTORS ENGAGED</div>
                    </th>
                    <th style={{ verticalAlign: "top" }}>
                      <div>MENTORS AVAILABLE</div>
                    </th>
                    {/* <th className="fixColumbnWidth7">REQUEST DATE</th> */}
                    <th style={{ verticalAlign: "top" }}>
                      <div
                        style={{
                          // display: "flex",
                          // justifyContent: "left",
                          // alignItems: "center",
                          // height: "60px",
                          // overflowWrap: "anywhere",
                          minWidth: "6rem",
                          maxWidth: "6.5rem",
                        }}
                      >
                        TOTAL STARTUPS
                      </div>
                    </th>
                    <th style={{ verticalAlign: "top" }}>
                      <div>STARTUPS ENGAGED</div>
                    </th>
                    <th style={{ verticalAlign: "top" }} className="">
                      <div>STARTUPS TO MATCH</div>
                    </th>
                    {/* <th>ACTION</th> */}
                  </tr>
                </thead>
                {cohortData && cohortData?.length > 0 ? (
                  cohortData.map((item, index) => (
                    <tbody>
                      <tr
                        className={
                          item.id === selectedRow ? "purpleBackground" : ""
                        }
                        key={index}
                      >
                        <td style={{ verticalAlign: "top" }}>
                          {getTableDataPaginate?.currentPage === 1 ? (
                            // <td style={{ verticalAlign: "top" }}>
                            //   {" "}
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "left",
                                alignItems: "center",
                                fontWeight: "normal",
                              }}
                            >
                              {index + 1}
                            </div>
                          ) : (
                            // </td>
                            // <td style={{ verticalAlign: "top" }}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "left",
                                alignItems: "center",
                              }}
                            >
                              {index +
                                1 +
                                10 * (getTableDataPaginate?.currentPage - 1)}
                            </div>
                            // </td>
                          )}
                        </td>
                        {/* 
                        <td
                          className="matchedTableMobile">

                          </td> */}
                        <td
                          style={{
                            display: "flex",
                            // justifyContent: "center",
                          }}
                          className="mtchmkingmendashmblreschrtdetails"
                        >
                          <div
                            className="newuserTooltip"
                            style={{
                              width: "100px",
                              height: "100px",
                              maxWidth: "none",
                              objectFit: "contain",
                            }}
                          >
                            <img
                              onClick={
                                () => {
                                  let reRoute = window.open(
                                    sample +
                                      `/cohort-programs/all/${item?.cohortApplicationId}`,
                                    "_blank"
                                  );
                                }
                                // history.push(`/cohort-programs/all/${item?.cohortID}`)
                              }
                              src={
                                item.banner === null ? hashImage : item.banner
                              }
                              className="sidebar-dashboard-icon2"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                                cursor: "pointer",
                                position: "relative",
                                // top: "1rem",
                              }}
                            />
                            <span
                              className="tooltiptext tooltip-bottom "
                              style={{
                                left: "32px",
                                top: "110px",
                                width: "160px",
                              }}
                            >
                              View Cohort Details
                            </span>
                            <div
                              style={{
                                flexDirection: "row",
                                // display: "flex",
                                justifyContent: "space-between",
                              }}
                              className="chrtdtlsmtchmakinginner1"
                            >
                              <div
                                className="chathistortdata"
                                style={{
                                  cursor: "pointer",
                                  alignItems: "center",
                                  display: "flex",
                                  minWidth: "100%",
                                  textAlign: "right",
                                  fontWeight: "normal",
                                }}
                              >
                                {"C" +
                                  item?.cohortId?.substring(
                                    item?.cohortId?.length - 6
                                  )}{" "}
                                <br></br>
                                {item.organizationName}
                                <br></br>
                                {item?.programName?.length > 20 ? (
                                  <div className="tooltipicon">
                                    {item?.programName.substring(0, 20)}
                                    <svg
                                      style={{
                                        position: "relative",
                                        top: "0.1rem",
                                        cursor: "pointer",
                                      }}
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="20"
                                      height="20"
                                      fill="currentColor"
                                      class="bi bi-three-dots"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
                                    </svg>
                                    <span className="tooltiptext7">
                                      <h5 style={{ color: "#fff" }}>
                                        Program Name
                                      </h5>
                                      {item?.programName}
                                    </span>
                                  </div>
                                ) : (
                                  item?.programName
                                )}
                                {/* {item.programName} */}
                                <br></br>
                                Start Date : 06-08-2022
                                <br></br>
                                Duration : {item.duration} Months
                                <br></br>
                              </div>
                              <div
                                className="newuserTooltip"
                                style={{
                                  cursor: "pointer",
                                  alignItems: "end",
                                  justifyContent: "end",

                                  minWidth: "40px",
                                  display: "flex",
                                }}
                              >
                                <img
                                  width="40px"
                                  src={profile}
                                  onClick={() => {
                                    let reRoute = window.open(
                                      sample +
                                        `/cohort-programs/all/${item?.cohortApplicationId}`,
                                      "_blank"
                                    );
                                  }}
                                />
                                <span
                                  className="tooltiptext tooltip-bottom "
                                  style={{
                                    left: "7px",
                                    top: "148px",
                                    width: "160px",
                                  }}
                                >
                                  View Cohort Details
                                </span>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className="mtchmkingmendashmblresnoshowdivtd ">
                          <div
                            style={{
                              flexDirection: "row",
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <div
                              style={{
                                cursor: "pointer",
                                alignItems: "center",
                                display: "flex",
                                minWidth: "200px",
                              }}
                            >
                              {"C" +
                                item?.cohortId?.substring(
                                  item?.cohortId?.length - 6
                                )}{" "}
                              <br></br>
                              {item.organizationName}
                              <br></br>
                              {item.programName}
                              <br></br>
                              Start Date : 06-08-2022
                              <br></br>
                              Duration : {item.duration} Months
                              <br></br>
                            </div>
                            <div
                              className="newuserTooltip"
                              style={{
                                cursor: "pointer",
                                alignItems: "end",
                                justifyContent: "center",

                                minWidth: "40px",
                                display: "flex",
                              }}
                            >
                              <img
                                src={profile}
                                onClick={() => {
                                  let reRoute = window.open(
                                    sample +
                                      `/cohort-programs/all/${item?.cohortApplicationId}`,
                                    "_blank"
                                  );
                                }}
                              />
                              <span
                                className="tooltiptext tooltip-bottom "
                                style={{
                                  left: "7px",
                                  top: "148px",
                                  width: "160px",
                                }}
                              >
                                View Cohort Details
                              </span>
                            </div>
                          </div>
                        </td>
                        <td
                          className=""
                          style={{ position: "relative", height: "100%" }}
                        >
                          <div className="IconWithData ttalmntrsinnerdivmtchmking">
                            <div className="middleData">
                              {item?.totalMentors}
                            </div>
                            {item?.totalMentors && item?.totalMentors !== 0 ? (
                              <div
                                className="d-flex justify-content-end newuserTooltip middleData2"
                                style={{
                                  cursor: "pointer",
                                  alignItems: "end",
                                  justifyContent: "center",
                                  // marginLeft: "61px",
                                  // width: "28%",
                                  display: "flex",
                                }}
                                onClick={() => {
                                  setCohortModalMentorData((data) => []);
                                  setModalVisibility(true);
                                  setFromModule("Mentor");
                                  setCohortModalData(item.cohortId);
                                  setCohortModalData2(item.cohortAdminId);
                                  setEngagedMentorDetails(false);
                                  setAvailableMentorDetails(false);
                                  setEngagedStartupDetails(false);
                                  setAvailableStartupDetails(false);
                                }}
                              >
                                <img
                                  src={mentorshipIcon4}
                                  height={40}
                                  width={40}
                                />
                                <span
                                  className="tooltiptext tooltip-bottom "
                                  style={{
                                    left: "7px",
                                    top: "148px",
                                    width: "160px",
                                  }}
                                >
                                  View Total Mentors
                                </span>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </td>
                        <td
                          className=""
                          // style={{ verticalAlign: "top" }}
                          style={{ position: "relative", height: "100%" }}
                        >
                          {/* <div>{item.mentorsEngaged}</div> */}
                          <div className="IconWithData ttalmntrsinnerdivmtchmking">
                            <div className="middleData">
                              {item?.mentorsEngaged}
                            </div>
                            {item?.mentorsEngaged &&
                            item?.mentorsEngaged !== 0 ? (
                              <div
                                className="d-flex justify-content-end newuserTooltip "
                                style={{
                                  cursor: "pointer",
                                  alignItems: "end",
                                  justifyContent: "center",
                                  // marginLeft: "61px",
                                  // width: "28%",
                                  display: "flex",
                                }}
                                onClick={() => {
                                  // setCohortModalMentorData((data) => []);
                                  setModalVisibility2(true);
                                  // setFromModule("Mentor");
                                  setCohortModalData(item.cohortId);
                                  // setCohortModalData2(item.cohortAdminId);
                                  setEngagedMentorDetails(true);
                                  setAvailableMentorDetails(false);
                                  setEngagedStartupDetails(false);
                                  setAvailableStartupDetails(false);
                                  engagedMentors(
                                    item.cohortId,
                                    item.cohortAdminId
                                  );
                                }}
                              >
                                <img
                                  src={mentorshipIcon4}
                                  height={40}
                                  width={40}
                                />
                                <span
                                  className="tooltiptext tooltip-bottom "
                                  style={{
                                    left: "7px",
                                    top: "148px",
                                    width: "180px",
                                  }}
                                >
                                  View Engaged Mentors
                                </span>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </td>
                        <td
                          // style={{ verticalAlign: "top" }}
                          style={{ position: "relative", height: "100%" }}
                        >
                          {/* {item.mentorsAvailable} */}
                          <div className="IconWithData ttalmntrsinnerdivmtchmking">
                            <div className="middleData">
                              {item?.mentorsAvailable}
                            </div>
                            {item?.mentorsAvailable &&
                            item?.mentorsAvailable !== 0 ? (
                              <div
                                className="d-flex justify-content-end newuserTooltip "
                                style={{
                                  cursor: "pointer",
                                  alignItems: "end",
                                  justifyContent: "center",
                                  // marginLeft: "61px",
                                  // width: "28%",
                                  display: "flex",
                                }}
                                onClick={() => {
                                  // setCohortModalMentorData((data) => []);
                                  setModalVisibility2(true);
                                  // setFromModule("Mentor");
                                  setCohortModalData(item.cohortId);
                                  // setCohortModalData2(item.cohortAdminId);
                                  setAvailableMentorDetails(true);
                                  setEngagedMentorDetails(false);
                                  setEngagedStartupDetails(false);
                                  setAvailableStartupDetails(false);
                                  availableMentors(
                                    item.cohortId,
                                    item.cohortAdminId
                                  );
                                }}
                              >
                                <img
                                  src={mentorshipIcon4}
                                  height={40}
                                  width={40}
                                />
                                <span
                                  className="tooltiptext tooltip-bottom "
                                  style={{
                                    left: "7px",
                                    top: "148px",
                                    width: "180px",
                                  }}
                                >
                                  View Available Mentors
                                </span>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </td>

                        <td
                          className=""
                          style={{ position: "relative", height: "100%" }}
                        >
                          <div className="IconWithData ttalmntrsinnerdivmtchmking">
                            <div className="middleData">
                              {item.totalStartups}
                            </div>
                            {item.totalStartups && item.totalStartups !== 0 ? (
                              <div
                                className="d-flex justify-content-end newuserTooltip "
                                style={{
                                  cursor: "pointer",
                                  alignItems: "end",
                                  justifyContent: "center",
                                  // marginLeft: "61px",
                                  // width: "28%",
                                  display: "flex",
                                }}
                                onClick={() => {
                                  setCohortModalMentorData((data) => []);
                                  setModalVisibility(true);
                                  setFromModule("Startup");
                                  setCohortModalData(item.cohortId);
                                  setCohortModalData2(item.cohortAdminId);
                                  setAvailableMentorDetails(false);
                                  setEngagedMentorDetails(false);
                                  setEngagedStartupDetails(false);
                                  setAvailableStartupDetails(false);
                                }}
                              >
                                <img
                                  src={startupMiniCircle}
                                  height={40}
                                  width={40}
                                />
                                <span
                                  className="tooltiptext tooltip-bottom "
                                  style={{
                                    left: "7px",
                                    top: "148px",
                                    width: "160px",
                                  }}
                                >
                                  View Total Startups
                                </span>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </td>
                        <td
                          className=""
                          // style={{
                          //   whiteSpace: "nowrap",
                          //   verticalAlign: "top",
                          // }}
                          style={{ position: "relative", height: "100%" }}
                        >
                          {/* {item.startupsEngaged} */}
                          <div className="IconWithData ttalmntrsinnerdivmtchmking">
                            <div className="middleData">
                              {item?.startupsEngaged}
                            </div>
                            {item.startupsEngaged &&
                            item.startupsEngaged !== 0 ? (
                              <div
                                className="d-flex justify-content-end newuserTooltip srtengmblmatchdiv"
                                style={{
                                  cursor: "pointer",
                                  alignItems: "end",
                                  justifyContent: "center",
                                  // marginLeft: "61px",
                                  // width: "28%",
                                  display: "flex",
                                  // paddingRight: "15px",
                                }}
                                onClick={() => {
                                  // setCohortModalMentorData((data) => []);
                                  setModalVisibility2(true);
                                  // setFromModule("Startup");
                                  setCohortModalData(item.cohortId);
                                  // setCohortModalData2(item.cohortAdminId);
                                  setAvailableMentorDetails(false);
                                  setEngagedMentorDetails(false);
                                  setEngagedStartupDetails(true);
                                  setAvailableStartupDetails(false);
                                  engagedStartups(
                                    item.cohortId,
                                    item.cohortAdminId
                                  );
                                }}
                              >
                                <img
                                  src={startupMiniCircle}
                                  // height={40}
                                  // width={40}
                                  // className=""
                                />
                                <span
                                  className="tooltiptext tooltip-bottom "
                                  style={{
                                    left: "7px",
                                    top: "148px",
                                    width: "180px",
                                  }}
                                >
                                  View Engaged Startups
                                </span>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </td>
                        <td
                          className=""
                          // style={{
                          //   whiteSpace: "nowrap",
                          //   verticalAlign: "top",
                          // }}
                          style={{ position: "relative", height: "100%" }}
                        >
                          {/* {item.startupsAvailable} */}
                          <div className="IconWithData ttalmntrsinnerdivmtchmking">
                            <div className="middleData">
                              {item?.startupsAvailable}
                            </div>
                            {item.startupsAvailable &&
                            item.startupsAvailable !== 0 ? (
                              <div
                                className="d-flex justify-content-end newuserTooltip srtengmblmatchdiv"
                                style={{
                                  cursor: "pointer",
                                  alignItems: "end",
                                  justifyContent: "center",
                                  // marginLeft: "61px",
                                  // width: "28%",
                                  display: "flex",
                                  // paddingRight: "15px",
                                }}
                                onClick={() => {
                                  // setCohortModalMentorData((data) => []);
                                  setModalVisibility2(true);
                                  // setFromModule("Startup");
                                  setCohortModalData(item.cohortId);
                                  // setCohortModalData2(item.cohortAdminId);
                                  setAvailableMentorDetails(false);
                                  setEngagedMentorDetails(false);
                                  setEngagedStartupDetails(false);
                                  setAvailableStartupDetails(true);
                                  availableStartups(
                                    item.cohortId,
                                    item.cohortAdminId
                                  );
                                }}
                              >
                                <img
                                  src={startupMiniCircle}
                                  // height={55}
                                  // width={55}
                                />
                                <span
                                  className="tooltiptext tooltip-bottom "
                                  style={{
                                    left: "-10px",
                                    top: "148px",
                                    width: "170px",
                                  }}
                                >
                                  View Available Startups
                                </span>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </td>
                        {/* <td>
                          <input
                            type="checkbox"
                            id="listItem"
                            name="listItem"
                            value={tableRow}
                            checked={tableRow}
                            onClick={() => {
                              if (tableRow === false) {
                                setCohortData([item]);
                                setTableRow(true);
                                mentorDropdownList(item.cohortId);
                                startupDropdownList(item.cohortId);
                                createMentorMatchInitial(item.cohortId);
                                setCohortIdTable(item.cohortId);
                              } else {
                                setCohortData(cohortListTable);
                                setTableRow(false);
                                setMatchMakingList([]);
                                setMentorFilterDropdDown((prevState) => []);
                                setStartupFilterDropdDown((prevState) => []);
                              }
                            }}
                          />
                        </td> */}
                      </tr>
                    </tbody>
                  ))
                ) : (
                  <tr>
                    <td colSpan={8} style={{ border: "none" }}>
                      {" "}
                      <div
                        className="no-records"
                        style={{ marginLeft: "8rem" }}
                      >
                        No Records Found
                      </div>
                    </td>
                  </tr>
                )}
              </table>
              {cohortListTablePaginate && !tableRow && (
                <div className="pagination-box">
                  {getTableDataPaginate !== undefined && (
                    <Pagination
                      activePage={activePage}
                      itemsCountPerPage={10}
                      //   totalItemsCount={
                      //     startUpApplicationPagineate?.totalElements
                      //   }
                      // cohortData?.length
                      totalItemsCount={getTableDataPaginate.totalElements}
                      pageRangeDisplayed={5}
                      onChange={handlePageChange.bind(this)}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
          {tableRow && (
            <>
              <div className="row matchMakingIntruction">
                Select Mentor & Startup and click on Create Match Button.
                <br></br>
                The MentorshipID is now Generated and Mentorship Engagement
                Process can start.
              </div>
              <div className="col-11 d-flex justify-content-between matchCreateDiv">
                <div className="matchTableBottomText col-2 matchTableBottomTextagain">
                  CREATE MATCH
                </div>
                <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip buttonSpacingBottom col-3">
                  <Select
                    required={true}
                    id="cohortorgname"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    name="cohortorgname"
                    className="col-12 gendermentorinput"
                    styles={customStyles}
                    value={filterMentorData}
                    onChange={(e) => {
                      setFilterMentorData(e);
                      setFilterStartupData({
                        label: "Select Startup",
                        value: "select",
                      });
                      if (e.value !== "select") {
                        getMentorsMatches(e.value);
                      }
                    }}
                    options={mentorFilterDropdDown}
                    placeholder="Select Mentor"
                  />
                  <span
                    className="tooltiptext tooltip-bottom"
                    style={{ left: "77px", top: "45px", width: "140px" }}
                  >
                    Search Mentor
                  </span>
                </div>
                <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip buttonSpacingBottom col-3">
                  <Select
                    className="selectstartupcreatematchmentor"
                    placeholder="Select Startup"
                    options={startupFilterDropdDown}
                    styles={customStyles}
                    value={filterStartupData}
                    onChange={(e) => {
                      setFilterStartupData(e);
                      if (e.value !== "select") getStartupMatches(e.value);
                    }}
                  />
                  <span
                    className="tooltiptext tooltip-bottom"
                    style={{ left: "77px", top: "45px", width: "140px" }}
                  >
                    Search Startup
                  </span>
                </div>
                <div className="col-2 createMatchAlignment newuserTooltip">
                  <Button
                    //   onClick={getTableDataStatus2}
                    text="CREATE MATCH"
                    className="filter-button top-btn newcoloredbtn  newBottomBtnWidth benheading"
                    onClick={() => createMentorMatch()}
                  ></Button>
                  <span
                    className="tooltiptext tooltip-bottom"
                    style={{ left: "77px", top: "45px", width: "170px" }}
                  >
                    Click to Create Match
                  </span>
                </div>
                <div className="col-2 newuserTooltip">
                  <Button
                    onClick={() => createMentorMatchInitial(cohortIdTable)}
                    text="VIEW ALL MATCHES"
                    className="filter-button top-btn newcoloredbtn  newBottomBtnWidth2 benheading"
                  ></Button>
                  <span
                    className="tooltiptext tooltip-bottom"
                    style={{ left: "158px", top: "38px", width: "190px" }}
                  >
                    Click to View All Matches
                  </span>
                </div>
              </div>
              {matchMakingList && matchMakingList?.length > 0 ? (
                <div className="matchMakingTable chrtadminmatchmkngmenloginmaindivtable2">
                  <div className="table-container mt-2">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th
                            style={{ verticalAlign: "top" }}
                            className="fixColumbnWidth4"
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "left",
                                alignItems: "center",
                              }}
                            >
                              NO.
                            </div>
                          </th>
                          <th
                            style={{ verticalAlign: "top" }}
                            className="fixColumbnWidth"
                            colspan="2"
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "left",
                                alignItems: "center",
                              }}
                            >
                              MENTOR DETAILS
                            </div>
                          </th>
                          <th
                            style={{
                              minWidth: "16.9rem",
                              maxWidth: "17rem",
                              verticalAlign: "top",
                            }}
                            colspan="2"
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "left",
                                alignItems: "center",
                              }}
                            >
                              STARTUPS
                            </div>
                          </th>
                          <th style={{ verticalAlign: "top" }}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "left",
                                alignItems: "center",

                                fontSize: "15px",
                              }}
                            >
                              MATCH CREATED MENTORSHIP ID
                            </div>
                          </th>
                          <th style={{ verticalAlign: "top" }}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "left",
                                alignItems: "center",
                              }}
                            >
                              SESSIONS
                            </div>
                          </th>
                          <th style={{ verticalAlign: "top" }}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "left",
                                alignItems: "center",

                                fontSize: "15px",
                              }}
                            >
                              HOURS
                            </div>
                          </th>
                          <th style={{ verticalAlign: "top" }}>
                            MENTORSHIP STATUS
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {matchMakingList && matchMakingList.length > 0 ? (
                          matchMakingList.map((item, index) => (
                            <tr>
                              <td style={{ verticalAlign: "top" }}>
                                {index + 1}
                              </td>
                              <td className="viewallmatchestd">
                                <div
                                  className="newuserTooltip"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    maxWidth: "none",
                                    objectFit: "contain",
                                  }}
                                >
                                  <img
                                    src={item.mentorImage}
                                    onClick={() =>
                                      ViewProfile(
                                        item?.mentorEmail,
                                        item?.mentorId
                                      )
                                    }
                                    className="sidebar-dashboard-icon2 newWidthIconFIx"
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "contain",
                                      cursor: "pointer",
                                    }}
                                  />
                                  <span
                                    className="tooltiptext tooltip-bottom "
                                    style={{
                                      left: "46px",
                                      top: "94px",
                                      width: "150px",
                                    }}
                                  >
                                    View Mentor Profile
                                  </span>
                                  <div className="mendetmobiledivmatches">
                                    <div>
                                      {"M" +
                                        item.mentorId.substring(
                                          item.mentorId.length - 6
                                        )}
                                    </div>
                                    <div className="mt-1">
                                      {item.mentorName}
                                    </div>

                                    <div className="mt-1">
                                      Cohort Mentorships :{" "}
                                      {item.cohortMentorships}
                                    </div>
                                    <div className="mt-1">
                                      Other Mentorships :{" "}
                                      {item.otherMentorships}
                                    </div>
                                    <div
                                      className="d-flex justify-content-end newuserTooltip"
                                      style={{
                                        cursor: "pointer",
                                        alignItems: "end",
                                        justifyContent: "center",
                                        width: "40px",
                                        display: "flex",
                                        float: "right",
                                      }}
                                      onClick={() =>
                                        ViewProfile(
                                          item?.mentorEmail,
                                          item?.mentorId
                                        )
                                      }
                                    >
                                      <img src={mentorMiniIcon} />
                                      <span
                                        className="tooltiptext tooltip-bottom"
                                        style={{
                                          left: "160px",
                                          top: "45px",
                                          width: "150px",
                                        }}
                                      >
                                        View Mentor Profile
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </td>

                              <td
                                className="matchedTableMentor matchedTableMentornew"
                                // style={{
                                //   minWidth: "12.9rem",
                                //   maxWidth: "13rem",
                                // }}
                              >
                                <div>
                                  {"M" +
                                    item.mentorId.substring(
                                      item.mentorId.length - 6
                                    )}
                                </div>
                                <div className="mt-1">{item.mentorName}</div>

                                <div className="mt-1">
                                  Cohort Mentorships : {item.cohortMentorships}
                                </div>
                                <div className="mt-1">
                                  Other Mentorships : {item.otherMentorships}
                                </div>
                                <div
                                  className="d-flex justify-content-end newuserTooltip"
                                  style={{
                                    cursor: "pointer",
                                    alignItems: "end",
                                    justifyContent: "center",
                                    width: "40px",
                                    display: "flex",
                                    float: "right",
                                  }}
                                  onClick={() =>
                                    ViewProfile(
                                      item?.mentorEmail,
                                      item?.mentorId
                                    )
                                  }
                                >
                                  <img src={mentorMiniIcon} />
                                  <span
                                    className="tooltiptext tooltip-bottom"
                                    style={{
                                      left: "160px",
                                      top: "45px",
                                      width: "150px",
                                    }}
                                  >
                                    View Mentor Profile
                                  </span>
                                </div>
                              </td>
                              <td className="matchedTableMobile" style={{}}>
                                {item?.mentorships !== undefined &&
                                  item?.mentorships?.length > 0 &&
                                  item?.mentorships.map(function (key, index) {
                                    return (
                                      <>
                                        {/* <td
                                          style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            height: "186px",
                                          }}
                                          className="borderStartUp7"
                                        > */}
                                        <div className="matchedTableMobileinnerdiv">
                                          <div
                                            className="newuserTooltip startupssectionpic"
                                            style={{
                                              marginLeft: "46%",
                                              width: "56%",
                                              height: "auto",
                                              maxWidth: "none",

                                              objectFit: "contain",
                                              marginTop: "21%",
                                            }}
                                          >
                                            <img
                                              src={
                                                key?.startup?.logo === null ||
                                                key?.startup?.logo === ""
                                                  ? hashImage
                                                  : key?.startup?.logo
                                              }
                                              onClick={() => {
                                                // setIndexCounter(item.requestId);
                                                redirectProfile(
                                                  key?.startup?.dippNumber
                                                );
                                              }}
                                              className="sidebar-dashboard-icon2"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "contain",
                                                cursor: "pointer",
                                                position: "relative",
                                                bottom: "2.25rem",
                                              }}
                                            />
                                            <span
                                              className="tooltiptext tooltip-bottom "
                                              style={{
                                                left: "40px",
                                                top: "88px",
                                                width: "170px",
                                              }}
                                            >
                                              View Startup Profile
                                            </span>
                                          </div>

                                          <div
                                            className="row"
                                            style={{
                                              justifyContent: "end",
                                            }}
                                          >
                                            <div
                                              style={{
                                                position: "relative",
                                                top: "0.75rem",
                                              }}
                                            >
                                              {key?.startup?.organization_name}
                                            </div>
                                            <div
                                              style={{
                                                // position: "relative",
                                                // top: "0.5rem",
                                                width: "max-content",
                                                cursor: "pointer",
                                                float: "right",
                                                position: "relative",
                                                top: "1.5rem",
                                              }}
                                              className="color-green newuserTooltip"
                                              onClick={() => {
                                                let requestJson = {
                                                  industry:
                                                    key.startup.industry,
                                                  sub_industry:
                                                    key.startup.subindustry,
                                                  function: key.startup.sectors,
                                                  sub_function:
                                                    key.startup.services,
                                                  stage: key.startup.stage,
                                                };
                                                setModalData(requestJson);
                                                setModalOpen(true);
                                              }}
                                            >
                                              {"S" +
                                                key?.startup?.id.substring(
                                                  key?.startup?.id.length - 6
                                                )}
                                              <span
                                                className="tooltiptext tooltip-bottom"
                                                style={{
                                                  left: "3rem",
                                                  top: "33px",
                                                  width: "220px",
                                                }}
                                              >
                                                View Mentorship Requirement
                                              </span>
                                            </div>
                                            <div
                                              style={{
                                                position: "relative",
                                                top: "1.5rem",
                                                // right: "1.5rem",
                                              }}
                                            >
                                              {"R" +
                                                key?.requestId.substring(
                                                  key?.requestId.length - 6
                                                )}
                                            </div>
                                            <div
                                              className="newuserTooltip"
                                              style={{
                                                width: "fit-content",
                                                paddingTop: "10%",
                                              }}
                                              onClick={() => {
                                                redirectProfile(
                                                  key?.startup?.dippNumber
                                                );
                                              }}
                                            >
                                              <img
                                                height={40}
                                                width={40}
                                                src={startupMiniCircle}
                                              />
                                              <span
                                                className="tooltiptext tooltip-bottom "
                                                style={{
                                                  left: "36px",
                                                  top: "50px",
                                                  width: "150px",
                                                }}
                                              >
                                                View Startup Profile
                                              </span>
                                            </div>
                                          </div>
                                          <div>
                                            <div
                                              style={{
                                                textAlign: "left",
                                                width: "50%",
                                                position: "absolute",
                                              }}
                                            >
                                              MATCH CREATED MENTORSHIP ID
                                            </div>
                                            <div>
                                              <div>
                                                <div>
                                                  M
                                                  {key?.id.substring(
                                                    key?.id?.length - 6
                                                  )}
                                                </div>
                                                <div>
                                                  {moment(
                                                    key?.mentorshipDate
                                                  ).format("DD/MM/YYYY")}
                                                  <br></br>
                                                  {moment(
                                                    key?.mentorshipDate
                                                  ).format("hh:mm a")}
                                                </div>
                                              </div>
                                              <div
                                                className="newuserTooltip startuponediv"
                                                style={{
                                                  cursor: "pointer",
                                                  position: "relative",
                                                  right: "0px",
                                                  bottom: "0px",
                                                  // padding: "3px",
                                                  display: "flex",
                                                  justifyContent: "right",
                                                }}
                                                onClick={() => {
                                                  window.open(
                                                    `/mentor-dashboard/mentorships/engagement-summary/${key?.id}`,
                                                    "_blank"
                                                  );
                                                }}
                                              >
                                                <img
                                                  src={mentorshipMiniCircle}
                                                  height={40}
                                                  width={40}
                                                />
                                                <span
                                                  className="tooltiptext tooltip-bottom "
                                                  style={{
                                                    left: "12px",
                                                    width: "212px",
                                                    top: "2rem",
                                                    position: "relative",
                                                  }}
                                                >
                                                  View Mentorship Engagement
                                                </span>
                                              </div>
                                            </div>
                                          </div>

                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                            }}
                                          >
                                            <div>SESSIONS</div>
                                            <div>
                                              <div
                                                style={{
                                                  position: "relative",
                                                  right: "0.25rem",
                                                }}
                                              >
                                                Total : {key?.sessionScheduled}
                                              </div>
                                              <div
                                                style={{
                                                  whiteSpace: "nowrap",
                                                  position: "relative",
                                                  right: "0.25rem",
                                                }}
                                              >
                                                Completed :{" "}
                                                {key?.sessionCompleted}
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                            }}
                                          >
                                            <div>HOURS</div>
                                            <div>
                                              <div
                                                style={{
                                                  position: "relative",
                                                  right: "0.25rem",
                                                }}
                                              >
                                                Total : {key?.hoursScheduled}
                                              </div>
                                              <div
                                                style={{
                                                  whiteSpace: "nowrap",
                                                  position: "relative",
                                                  right: "0.25rem",
                                                }}
                                              >
                                                Completed :{" "}
                                                {key?.hoursCompleted}
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                            }}
                                          >
                                            <div>MENTORSHIP STATUS</div>

                                            <div>
                                              {key?.mentorshipStatus ===
                                              "ACTIVE"
                                                ? "Ongoing"
                                                : "Completed"}
                                            </div>
                                          </div>
                                        </div>

                                        {/* </td> */}
                                      </>
                                    );
                                  })}
                              </td>
                              <td
                                className="matchList-tooltip p-0 matchedTableWeb"
                                style={{
                                  minWidth: "9.2rem",
                                  maxWidth: "9.25rem",
                                  verticalAlign: "top",
                                }}
                              >
                                {item?.mentorships !== undefined &&
                                  item?.mentorships?.length > 0 &&
                                  item?.mentorships.map(function (key, index) {
                                    return (
                                      <>
                                        <td
                                          style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            height: "186px",
                                          }}
                                          className="borderStartUp7"
                                        >
                                          <div
                                            className="newuserTooltip"
                                            style={{
                                              width: "100px",
                                              height: "100px",
                                              maxWidth: "none",

                                              objectFit: "contain",
                                            }}
                                          >
                                            <img
                                              src={
                                                key?.startup?.logo === null ||
                                                key?.startup?.logo === ""
                                                  ? hashImage
                                                  : key?.startup?.logo
                                              }
                                              onClick={() => {
                                                redirectProfile(
                                                  key?.startup?.dippNumber
                                                );
                                              }}
                                              className="sidebar-dashboard-icon2"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "contain",
                                                cursor: "pointer",
                                                position: "relative",
                                                bottom: "2.25rem",
                                              }}
                                            />
                                            <span
                                              className="tooltiptext tooltip-bottom "
                                              style={{
                                                left: "40px",
                                                top: "88px",
                                                width: "170px",
                                              }}
                                            >
                                              View Startup Profile
                                            </span>
                                          </div>
                                        </td>
                                      </>
                                    );
                                  })}
                              </td>
                              <td
                                className="matchList-tooltip p-0 matchedTableWeb"
                                style={{
                                  minWidth: "11.9rem",
                                  maxWidth: "12rem",
                                  position: "relative",
                                  verticalAlign: "top",
                                }}
                              >
                                {item?.mentorships !== undefined &&
                                  item?.mentorships?.length > 0 &&
                                  item?.mentorships.map(function (key, index) {
                                    return (
                                      <>
                                        <td
                                          style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            height: "186px",
                                          }}
                                          className="borderStartUp7"
                                        >
                                          <div className="">
                                            <div
                                              style={{
                                                // position: "relative",
                                                // top: "0.5rem",
                                                width: "max-content",
                                                cursor: "pointer",
                                              }}
                                              className="color-green newuserTooltip"
                                              onClick={() => {
                                                let requestJson = {
                                                  industry:
                                                    key.startup.industry,
                                                  sub_industry:
                                                    key.startup.subindustry,
                                                  function: key.startup.sectors,
                                                  sub_function:
                                                    key.startup.services,
                                                  stage: key.startup.stage,
                                                };
                                                setModalData(requestJson);
                                                setModalOpen(true);
                                              }}
                                            >
                                              {"S" +
                                                key?.startup?.id.substring(
                                                  key?.startup?.id.length - 6
                                                )}
                                              <span
                                                className="tooltiptext tooltip-bottom"
                                                style={{
                                                  left: "3rem",
                                                  top: "33px",
                                                  width: "220px",
                                                }}
                                              >
                                                View Mentorship Requirement
                                              </span>
                                            </div>
                                            <div
                                              style={{
                                                position: "relative",
                                                top: "0.75rem",
                                              }}
                                            >
                                              {key?.startup?.organization_name}
                                            </div>

                                            <div
                                              style={{
                                                position: "relative",
                                                top: "0.75rem",
                                              }}
                                            >
                                              {"R" +
                                                key?.requestId.substring(
                                                  key?.requestId.length - 6
                                                )}
                                            </div>
                                            <div
                                              className="newuserTooltip"
                                              style={{
                                                cursor: "pointer",
                                                position: "absolute",
                                                padding: "5px",
                                                right: "0px",
                                                bottom: "0px",
                                              }}
                                              onClick={() => {
                                                redirectProfile(
                                                  key?.startup?.dippNumber
                                                );
                                              }}
                                            >
                                              <img
                                                height={40}
                                                width={40}
                                                src={startupMiniCircle}
                                              />
                                              <span
                                                className="tooltiptext tooltip-bottom "
                                                style={{
                                                  left: "36px",
                                                  top: "50px",
                                                  width: "150px",
                                                }}
                                              >
                                                View Startup Profile
                                              </span>
                                            </div>
                                          </div>
                                        </td>
                                      </>
                                    );
                                  })}
                              </td>
                              <td
                                className="matchList-tooltip p-0 matchedTableWeb"
                                style={{
                                  minWidth: "9.2rem",
                                  maxWidth: "9.25rem",
                                  position: "relative",
                                  verticalAlign: "top",
                                }}
                              >
                                {item.mentorships !== undefined &&
                                  item.mentorships?.length > 0 &&
                                  item.mentorships.map(function (key, index) {
                                    return (
                                      <>
                                        <td
                                          style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            height: "186px",
                                          }}
                                          className="borderStartUp7"
                                        >
                                          <div>
                                            <div>
                                              M
                                              {key?.id.substring(
                                                key?.id?.length - 6
                                              )}
                                            </div>
                                            <div>
                                              {moment(
                                                key?.mentorshipDate
                                              ).format("DD/MM/YYYY")}
                                              <br></br>
                                              {moment(
                                                key?.mentorshipDate
                                              ).format("hh:mm a")}
                                            </div>
                                          </div>
                                          <div
                                            className="newuserTooltip"
                                            style={{
                                              cursor: "pointer",
                                              position: "absolute",
                                              right: "0px",
                                              bottom: "0px",
                                              padding: "3px",
                                            }}
                                            onClick={() => {
                                              window.open(
                                                `/mentor-dashboard/mentorships/engagement-summary/${key?.id}`,
                                                "_blank"
                                              );
                                            }}
                                          >
                                            <img
                                              src={mentorshipMiniCircle}
                                              height={40}
                                              width={40}
                                            />
                                            <span
                                              className="tooltiptext tooltip-bottom "
                                              style={{
                                                left: "12px",
                                                width: "212px",
                                                top: "49px",
                                              }}
                                            >
                                              View Mentorship Engagement
                                            </span>
                                          </div>
                                        </td>
                                      </>
                                    );
                                  })}
                              </td>
                              <td className="matchList-tooltip p-0 matchedTableWeb">
                                {item?.mentorships !== undefined &&
                                  item?.mentorships?.length > 0 &&
                                  item?.mentorships.map(function (key, index) {
                                    return (
                                      <>
                                        <td
                                          style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            height: "186px",
                                          }}
                                          className="borderStartUp7"
                                        >
                                          <div>
                                            <div
                                              style={{
                                                position: "relative",
                                                right: "0.25rem",
                                              }}
                                            >
                                              Total : {key?.sessionScheduled}
                                            </div>
                                            <div
                                              style={{
                                                whiteSpace: "nowrap",
                                                position: "relative",
                                                right: "0.25rem",
                                              }}
                                            >
                                              Completed :{" "}
                                              {key?.sessionCompleted}
                                            </div>
                                          </div>
                                        </td>
                                      </>
                                    );
                                  })}
                              </td>
                              <td className="matchList-tooltip p-0 matchedTableWeb">
                                {item?.mentorships !== undefined &&
                                  item?.mentorships?.length > 0 &&
                                  item?.mentorships.map(function (key, index) {
                                    return (
                                      <>
                                        <td
                                          style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            height: "186px",
                                          }}
                                          className="borderStartUp7"
                                        >
                                          <div>
                                            <div
                                              style={{
                                                position: "relative",
                                                right: "0.25rem",
                                              }}
                                            >
                                              Total : {key?.hoursScheduled}
                                            </div>
                                            <div
                                              style={{
                                                whiteSpace: "nowrap",
                                                position: "relative",
                                                right: "0.25rem",
                                              }}
                                            >
                                              Completed : {key?.hoursCompleted}
                                            </div>
                                          </div>
                                        </td>
                                      </>
                                    );
                                  })}
                              </td>
                              <td className="matchList-tooltip p-0 matchedTableWeb">
                                {item?.mentorships !== undefined &&
                                  item?.mentorships?.length > 0 &&
                                  item?.mentorships.map(function (key, index) {
                                    return (
                                      <>
                                        <td
                                          style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            height: "186px",
                                          }}
                                          className="borderStartUp7"
                                        >
                                          <div>
                                            <div>
                                              {key?.mentorshipStatus ===
                                              "ACTIVE"
                                                ? "Ongoing"
                                                : "Completed"}
                                            </div>
                                          </div>
                                        </td>
                                      </>
                                    );
                                  })}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={8} style={{ border: "none" }}>
                              {" "}
                              <div
                                className="no-records"
                                style={{ marginLeft: "8rem" }}
                              >
                                No Matches Found
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    <div className="pagination-box">
                      {/* {mentorList && mentorList.length > 0 ? ( */}
                      <Pagination
                        activePage={activePage}
                        itemsCountPerPage={10}
                        //   totalItemsCount={mentorListPaginate.totalElements}
                        pageRangeDisplayed={5}
                        //   onChange={handlePageChange.bind(this)}
                      />
                      {/* ) : (
                    ""
                  )} */}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="no-records">
                  Please Select Mentor and Startup from the dropdown to Create a
                  Match
                </div>
              )}{" "}
            </>
          )}

          {/* <div
            className="dashboard-bottom-btn top-btn dashboardbelowBtn"
            style={{ margin: "auto" }}
            onClick={() => {
              history.push({
                state: {
                  fromModule: "startUpApplications",
                },
              });
              localStorage.setItem("allStartupList", "allStartupList");
              window.location.reload();
            }}
          >
            <p style={{ cursor: "pointer" }} className="text-white3">
              VIEW STARTUP LIST
            </p>
          </div> */}
          <Modal
            modalOpen={modalOpen}
            setModalOpen={setModalOpen}
            modalData={modalData}
          />
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    startUpApplication: state.StartUpReducer.StartUpApplications.data,
    startUpApplicationPagineate:
      state.StartUpReducer.StartUpApplications.paginate,
    getCounterStartUp: state.StartUpReducer.getCountersStartUpList.data,
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
    getNamesListData: state.AdminMentorReducer.getNamesList?.data,
    getTableData: state.MentorReducer.getCohortMentorList.data,
    getTableDataPaginate: state.MentorReducer.getCohortMatchTable.paginate,
    cohortMentorData: state.MentorReducer.getCohortMentorModuleList.data,
    cohortStartupData:
      state.MentorReducer.getStartupCohortMentorModuleList.data,
    cohortListTable: state.MentorReducer.getCohortMatchTable.data,
    cohortListTablePaginate: state.MentorReducer.getCohortMatchTable.paginate,
    cohortMentorDropdown: state.MentorReducer.getMatchMentorList.data,
    cohortStartupDropdown: state.MentorReducer.getMatchStartupList.data,
    cohortMatchRequest: state.MentorReducer.getMatchMakingRequest,
    cohortMatchMakingList: state.MentorReducer.getMatchMakingResult.data,
    getStepperData: state.AdminMentorReducer.getStepperList.list,
  };
};
export default connect(mapStateToProps, {
  //   getStartupApplication,
  //   getCountersStartUpList,
  matchTableCohortList,
  matchTableStartupList,
  matchTableMentorList,
  postMatchTableRequest,
  getmatchTableList,
  postMentorModuleCohort,
  postMentorModuleStartupCohort,
  getPredefineOptionsList,
  getNamesList,
  getStepperTooltipData,
  // getMentorCohortApplicationList,
})(withRouter(CohortMatchTable));
